module.exports = "/assets/54ef10363f7c5e7ded87e64aa2d0aec7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/QT.png
// module id = 1763
// module chunks = 0